import { docKey, genDeadlines, type Data, type Deadline, type Settings } from '@biuro/shared';
import { useState } from 'react';
import { DeadlineRow } from '../ui.tsx';
import { useDeleteDoc, useSaveDoc } from '../hooks.tsx';
import { CustomForm } from '../forms/CustomForm.tsx';

export function deadlines(st: Settings, data: Data, fromYM: string, toYM: string): Deadline[] {
  return genDeadlines(st, fromYM, toYM, data.custom, { rodoReviewedAt: data.rodo.main?.reviewedAt });
}

/** Dodatkowa informacja przy terminie: stan dokumentów w inFakcie. */
export function extraFor(d: Deadline, data: Data): string | undefined {
  if (d.id.startsWith('infakt-')) {
    const ym = d.id.slice(7);
    const active = Object.entries(data.infaktTemplates).filter(([, t]) => t.active !== false);
    if (!active.length) return 'dodaj szablony dokumentów';
    const ok = active.filter(([id]) => ['created', 'found', 'manual'].includes(data.infaktDocs[docKey(id, ym)]?.status || '')).length;
    return `wystawione ${ok} z ${active.length}`;
  }
  return undefined;
}

export function DeadlineList({ list, data }: { list: Deadline[]; data: Data }) {
  const save = useSaveDoc();
  const del = useDeleteDoc();
  const [edit, setEdit] = useState<string | null>(null);
  return (
    <>
      {list.map((d) => (
        <DeadlineRow
          key={d.id}
          d={d}
          done={!!data.done[d.id]}
          extra={extraFor(d, data)}
          onToggle={(v) => (v ? save.mutate({ col: 'done', id: d.id, doc: { at: new Date().toISOString() } }) : del.mutate({ col: 'done', id: d.id }))}
          onEdit={d.customId ? () => setEdit(d.customId!) : undefined}
        />
      ))}
      {edit && <CustomForm id={edit} onClose={() => setEdit(null)} />}
    </>
  );
}
